module.exports = __webpack_public_path__ + "img/kotlin.4d393899.svg";